import React from 'react'

import NissanIcon from './nissan.svg'
import ChevroletIcon from './chevrolet.svg'
import AudiIcon from './audi.svg'
import BMWIcon from './bmw.svg'
import DodgeIcon from './dodge.svg'
import FordIcon from './ford.svg'
import KiaIcon from './kia.svg'
import HondaIcon from './honda.svg'
import MazdaIcon from './mazda.svg'
import ToyotaIcon from './toyota.svg'
import VolkswagenIcon from './volkswagen.svg'
import HyundaiIcon from './hyundai.svg'
import AcuraIcon from './acura.svg'
import AlfaRomeoIcon from './alfa-romeo.svg'
import BuickIcon from './buick.svg'
import CadillacIcon from './cadillac.svg'
import ChryslerIcon from './chrysler.svg'
import FiatIcon from './fiat.svg'
import GMCIcon from './gmc.svg'
import InfinitiIcon from './infiniti.svg'
import JACIcon from './jac.svg'
import JaguarIcon from './jaguar.svg'
import JeepIcon from './jeep.svg'
import LamborghiniIcon from './lamborghini.svg'
import LandRoverIcon from './land-rover.svg'
import LincolnIcon from './lincoln.svg'
import MaseratiIcon from './maserati.svg'
import MercedesBenzIcon from './mercedes-benz.svg'
import MiniIcon from './mini.svg'
import MitsubishiIcon from './mitsubishi.svg'
import PeugeotIcon from './peugeot.svg'
import PorscheIcon from './porsche.svg'
import RAMIcon from './ram.svg'
import RenaultIcon from './renault.svg'
import SEATIcon from './seat.svg'
import SubaruIcon from './subaru.svg'
import SuzukiIcon from './suzuki.svg'
import VolvoIcon from './volvo.svg'
import BaicIcon from './baic.svg'
import SmartIcon from './smart.svg'
import FerrariIcon from './ferrari.svg'
import AstonMartinIcon from './aston-martin.svg'
import McLarenIcon from './mclaren.svg'
import BentleyIcon from './bentley.svg'
import HummerIcon from './hummer.svg'
import MercuryIcon from './mercury.svg'
import TeslaIcon from './tesla.svg'
import MgIcon from './mg.svg'
import Cupra from './cupra.svg'
import Chirey from './chirey.svg'

export const MAKER_ICONS = {
  nissan: NissanIcon,
  chevrolet: ChevroletIcon,
  audi: AudiIcon,
  bmw: BMWIcon,
  dodge: DodgeIcon,
  ford: FordIcon,
  kia: KiaIcon,
  honda: HondaIcon,
  mazda: MazdaIcon,
  toyota: ToyotaIcon,
  volkswagen: VolkswagenIcon,
  hyundai: HyundaiIcon,
  acura: AcuraIcon,
  'alfa romeo': AlfaRomeoIcon,
  buick: BuickIcon,
  cadillac: CadillacIcon,
  chrysler: ChryslerIcon,
  fiat: FiatIcon,
  gmc: GMCIcon,
  infiniti: InfinitiIcon,
  jac: JACIcon,
  jaguar: JaguarIcon,
  jeep: JeepIcon,
  lamborghini: LamborghiniIcon,
  'land rover': LandRoverIcon,
  lincoln: LincolnIcon,
  maserati: MaseratiIcon,
  'mercedes-benz': MercedesBenzIcon,
  'mercedes benz': MercedesBenzIcon,
  mini: MiniIcon,
  mitsubishi: MitsubishiIcon,
  peugeot: PeugeotIcon,
  porsche: PorscheIcon,
  ram: RAMIcon,
  renault: RenaultIcon,
  seat: SEATIcon,
  subaru: SubaruIcon,
  suzuki: SuzukiIcon,
  volvo: VolvoIcon,
  baic: BaicIcon,
  smart: SmartIcon,
  ferrari: FerrariIcon,
  'aston martin': AstonMartinIcon,
  mclaren: McLarenIcon,
  bentley: BentleyIcon,
  hummer: HummerIcon,
  mercury: MercuryIcon,
  tesla: TeslaIcon,
  mg: MgIcon,
  cupra: Cupra,
  chirey: Chirey,
}

export const getIcon = (iconName) => {
  const Component = MAKER_ICONS[iconName]
  if (Component) {
    return (
      <Component fill="#828282" />
    )
  }
  return null
}
